import React from 'react';
import cx from 'classnames';

import {
  Button,
  Border,
  Chip,
  FileAction,
  Text,
  StepLabelList,
} from 'spindl-shared-components';

import styles from './DownloadCSV.module.scss';
import usePresenter from './DownloadCSV.presenter';
import getProps from './DownloadCSV.props';
import { DownloadCSVCombinedProps } from './types';


const DownloadCSV: React.FC<DownloadCSVCombinedProps> = (props) => {
  const {
    className,
    classes,
    button,
    stepLabelList,
    border,
    label,
    instructions,
    text,
    chip,
    fileAction,
    button1,
    backButton,
    continueButton,
  } = usePresenter(props);

  const internalProps = getProps('');
  const currentStyle = styles.downloadCSV;

  return (
    <div className={cx(currentStyle, className)}>
      <div className={cx(styles.topContent, classes?.topContent)}>
        <div className={cx(styles.header, classes?.header)}>
          <Button
            className={cx(styles.button, classes?.button)}
            {...internalProps.button}
            {...button}/>
        </div>
        <StepLabelList
          className={cx(styles.stepLabelList, classes?.stepLabelList)}
          {...internalProps.stepLabelList}
          {...stepLabelList}/>
        <Border
          className={cx(styles.border, classes?.border)}
          {...internalProps.border}
          {...border}/>
      </div>
      <div className={cx(styles.middleContent, classes?.middleContent)}>
        <Text
          className={cx(styles.label, classes?.label)}
          {...internalProps.label}
          {...label}/>
        <Text
          className={cx(styles.instructions, classes?.instructions)}
          {...internalProps.instructions}
          {...instructions}/>
        <div className={cx(styles.roleText, classes?.roleText)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
          <Chip
            className={cx(styles.chip, classes?.chip)}
            {...internalProps.chip}
            {...chip}/>
        </div>
        <FileAction
          className={cx(styles.fileAction, classes?.fileAction)}
          {...internalProps.fileAction}
          {...fileAction}/>
        <Button
          className={cx(styles.button1, classes?.button1)}
          {...internalProps.button1}
          {...button1}/>
      </div>
      <div className={cx(styles.bottomContent, classes?.bottomContent)}>
        <Button
          className={cx(styles.backButton, classes?.backButton)}
          {...internalProps.backButton}
          {...backButton}/>
        <Button
          className={cx(styles.continueButton, classes?.continueButton)}
          {...internalProps.continueButton}
          {...continueButton}/>
      </div>
    </div>
  );
};

export default DownloadCSV;

